import "./add_jquery.js";

import Rails from "@rails/ujs";
import "bootstrap/dist/js/bootstrap";

import "./jquery_nested_form.js";

import { showLocalizationNormalizedFieldset, showLocalizationRawJSON } from "./default.js";
import "./wickedpicker.js";

window.showLocalizationRawJSON = showLocalizationRawJSON;
window.showLocalizationNormalizedFieldset = showLocalizationNormalizedFieldset;

// Start Rails UJS after everything is loaded
Rails.start();
